







































import { defineComponent, onBeforeMount, onMounted, ref } from '@vue/composition-api';
import { SlideOrigin } from '../../transitions/slide-in-out';
import { IconSize } from '../base-icon';
import gaClickOutside from '../../directives/ga-click-outside';

export default defineComponent({
  name: 'BaseSideSheet',
  directives: {
    gaClickOutside,
  },
  model: {
    event: 'update:model-value',
    prop: 'modelValue',
  },
  props: {
    closeButtonDataExternal: {
      type: String,
      default: 'slide-sheet-close-button',
    },
    appendToBody: {
      type: Boolean,
    },
    //prop is not used in lib-ui since vue2 dont have teleport tag, where this prop is used in fried tofu
    //one can still pass the prop, and then it will be used when we migrate
    container: {
      type: HTMLElement,
      default: undefined,
    },
    title: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 600,
    },
    blurredHeader: {
      type: Boolean,
    },
    modelValue: {
      type: Boolean,
      default: true,
    },
    preventCloseOnClickOutside: {
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const sideSheetContainer = ref(null);

    const hasScrolled = ref(false);
    const checkScrollPosition = () => {
      hasScrolled.value = sideSheetContainer.value.scrollTop > 0;
    };

    const close = () => {
      emit('update:model-value', false);
    };

    const closeOnClickOutside = () => {
      if (props.preventCloseOnClickOutside) return;
      close();
    };

    onMounted(() => {
      sideSheetContainer.value?.addEventListener('scroll', checkScrollPosition, { passive: true });
    });

    onBeforeMount(() => {
      sideSheetContainer.value?.removeEventListener('scroll', checkScrollPosition);
    });

    return {
      IconSize,
      SlideOrigin,
      close,
      closeOnClickOutside,
      sideSheetContainer,
      hasScrolled,
    };
  },
});
